import React from "react"
import {Badge} from "reactstrap";
import BaseComponent from "../BaseComponent";
import * as PropTypes from "prop-types";
import {_POSTPONED, _CLOSED, _NOT_PASS, _PASS, _SUSPENDED, _TAKEN, INSPECTION_STATUS_COLOR} from "../../utils/Global";

class StatusIndicator extends BaseComponent{

    render() {
        let status = this.props.status??{}
        let statusColors = this.props.statusColors??INSPECTION_STATUS_COLOR
        return (
            <Badge
                style={{background:statusColors[status.name],
                    borderRadius: '50%',
                    width:'18px',
                    height:'18px',
                    marginLeft:'16px',
                    top:'50%',
                    bottom:'50%',
                    position:'absolute',
                    transform: 'translate(-50%, -50%)'}}>
            </Badge>
        );
    }
}
StatusIndicator.propTypes = {
    status:PropTypes.object.isRequired,
    statusColors:PropTypes.array
}

export default StatusIndicator;